<template>
  <el-dialog
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="dataForm.roleName" placeholder="角色名称"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      <el-form-item size="mini" label="页面权限">
        <el-tree
                check-strictly
                :data="menuList"
                :props="menuListTreeProps"
                node-key="menuId"
                ref="menuListTree"
                :default-expand-all="true"
                show-checkbox>
        </el-tree>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        menuList: [],
        menuListTreeProps: {
          label: 'name',
          children: 'children'
        },
        orgListTreeProps: {
          label: 'orgName',
          children: 'children'
        },
        dataForm: {
          id: 0,
          roleName: '',
          remark: '',
          createTime: '',
          createUserId:''
        },
        dataRule: {
          roleName: [
            {required: true, message: '角色名称不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      init (id) {
        console.log(this.dataForm)
        this.dataForm.id = id || 0

        this.$http({
          url: '/bjba/sys/role/myMenu',
          method: 'get'
        }).then(({data}) => {
          this.menuList = this.treeDataTranslate(data.data, 'menuId')
        }).then(() => {
          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.$refs.menuListTree.setCheckedKeys([])
          })
        }).then(() => {
          if (this.dataForm.id) {
            this.$http({
              url: `/bjba/sys/role/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.dataForm.roleName = data.data.roleName
                this.dataForm.remark = data.data.remark
                this.dataForm.createTime = data.data.createTime
                this.dataForm.createUserId = data.data.createUserId
                this.$refs.menuListTree.setCheckedKeys(data.data.menuIdList)

              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/bjba/sys/role/save`,
              method: 'post',
              data: {
                'roleId': this.dataForm.id || undefined,
                'roleName': this.dataForm.roleName,
                'remark': this.dataForm.remark,
                'createTime': this.dataForm.createTime,
                'menuIdList': [].concat(this.$refs.menuListTree.getCheckedKeys(), this.$refs.menuListTree.getHalfCheckedKeys()),
                'createUserId': this.dataForm.createUserId
              }
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: 'error',
                  duration: 1500
                })
              }
            })
          }
        })
      },
      /**
       * 树形数据转换
       * @param {*} data list数据
       * @param {*} id 主键ID
       * @param {*} pid 上级ID
       * @param childrenKey 子list数据的key
       */
      treeDataTranslate (data, id = 'id', pid = 'parentId', childrenKey = 'children') {
        let res = []
        let temp = {}
        for (let i = 0; i < data.length; i++) {
          temp[data[i][id]] = data[i]
        }
        for (let k = 0; k < data.length; k++) {
          if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]][childrenKey]) {
              temp[data[k][pid]][childrenKey] = []
            }
            if (!temp[data[k][pid]]['_level']) {
              temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            temp[data[k][pid]][childrenKey].push(data[k])
          } else {
            res.push(data[k])
          }
        }
        return res
      }
    }
  }
</script>
